import { ExamSessionDetails } from '../../../../../../../../api/types/programs/course/exams/response/exam-metadata';
import { toast } from 'react-toastify';
import appApi from '../../../../../../../../api/app-api';

export const updateSessionRegistrationDatesOperation = async (
  currentProgramId: number | undefined,
  currentCourseId: number | undefined,
  examId: number,
  examSessionDetails: ExamSessionDetails,
  registrationStartDate: Date | undefined,
  registrationEndDate: Date | undefined,
  setSessionDetails: (sessionDetails: ExamSessionDetails[]) => any,
) => {
  try {
    if (!currentProgramId || !currentCourseId) {
      toast.warn('לא ניתן לאתר את מזהה התוכנית ו/או הקורס');
      return;
    }

    if (!registrationStartDate) {
      toast.warn('תחילה יש לבחור תאריכי הרשמה');
    }

    if (
      registrationStartDate &&
      registrationEndDate &&
      new Date(registrationEndDate)!.getTime() <
        new Date(registrationStartDate)!.getTime()
    ) {
      toast.warn('תאריך סיום חייב להיות אחרי תאריך ההתחלה');
      return;
    }

    const res = await appApi.updateRegistration(
      currentProgramId,
      currentCourseId,
      examId,
      examSessionDetails.id,
      registrationStartDate!,
      registrationEndDate!,
    );

    setSessionDetails(res.data.body);
  } catch (e) {
    console.error(
      `updateSessionRegistrationDatesOperation is failed with the currentProgramId: ${currentProgramId}, currentCourseId: ${currentCourseId}, examId: ${examId}, examSessionDetails: ${examSessionDetails}, registrationStartDate: ${registrationStartDate}, registrationEndDate: ${registrationEndDate}, with the error: ${e}`,
    );
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
  }
};
